module.exports = __webpack_public_path__ + "img/单位能耗成本@3x.cba774da.png";